import { render, staticRenderFns } from "./homeCom.vue?vue&type=template&id=4f10731c&scoped=true"
import script from "./homeCom.vue?vue&type=script&lang=js"
export * from "./homeCom.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f10731c",
  null
  
)

export default component.exports